import styled from 'styled-components';

import { breakpoints, colors, fontFamily } from '../../ui/variables';

export const ReportTableContentStyle = styled.div`
  .table-title {
    ${fontFamily.sourceSansPro.bold}
    color: ${colors.grayishBlue};
    font-size: 14px;
    line-height: 18px;
    margin-top: 16px;
    padding: 0 20px;

    @media (min-width: ${breakpoints.ipad.width}px) {
      margin-bottom: 8px;
      margin-top: 0;
    }
  }

  .table-content {
    background-color: ${colors.mostlyWhite};
    border-radius: 12px;
    color: ${colors.veryDarkGrayishBlue};
    overflow: hidden;

    .table-content-name {
      ${fontFamily.sourceSansPro.bold}
      font-size: 14px;
      line-height: 18px;
      padding: 20px 20px 12px;

      @media (min-width: ${breakpoints.ipad.width}px) {
        padding: 24px 20px 12px;
      }
    }

    .table-content-rows {
      &.no-border-bottom-radius {
        .content-row {
          &:last-child {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
          }
        }
      }

      .content-row {
        align-items: center;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        padding: 8px 0;

        &:nth-child(2n + 1) {
          background-color: ${colors.white};
        }

        &:last-child {
          border-bottom-left-radius: 12px;
          border-bottom-right-radius: 12px;
          padding-bottom: 20px;

          @media (min-width: ${breakpoints.ipad.width}px) {
            padding-bottom: 24px;
          }
        }

        .content-row-label {
          ${fontFamily.sourceSansPro.regular}
          flex-basis: 40%;
          font-size: 12px;
          line-height: 16px;
          padding-left: 20px;
        }

        .content-row-value {
          ${fontFamily.sourceSansPro.bold}
          flex-basis: 60%;
          font-size: 14px;
          line-height: 18px;
          padding-right: 20px;
          overflow-wrap: break-word;
          width: 200px;
        }
      }
    }
  }
`;
